export const QUESTIONS_AMOUNT_BASIC = 9;
export const ADDITIONAL_QUESTION_REQUESTED = 3;
